import React from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'
import OptionallyDisplayed from '../../optionally_displayed/index'
import Error from '../errors/index'

export default class AbstractInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      validationErrors: props.errors,
      pristine: true,
    }
    this.handleChanged = this.handleChanged.bind(this)
    this.losePristine = this.losePristine.bind(this)
  }

  componentDidMount() {
    if (!this.props.validationKey) {
      return
    }
    this.errorSubscription = this.props.errorsDispatcher.errorsSubscription
      .filter(
        (validationsErrors) =>
          validationsErrors[this.props.validationKey] || this.state.validationErrors,
      )
      .subscribe((validationsErrors) => {
        this.setState({
          validationErrors: validationsErrors[this.props.validationKey] || [],
        })
      })
  }

  componentWillUnmount() {
    if (this.props.validationKey) {
      this.errorSubscription.unsubscribe()
    }
  }

  handleChanged(ev) {
    let newState = update(this.state, {
      pristine: { $set: false },
      value: { $set: ev.target.value },
    })
    this.setState(newState, this.props.onFieldChanged(ev))
  }

  displayErrors() {
    return (
      <OptionallyDisplayed display={this.state.validationErrors.length > 0 && !this.state.pristine}>
        <Error errors={this.state.validationErrors} />
      </OptionallyDisplayed>
    )
  }

  get className() {
    return this.props.errorText === ''
      ? `errors-field ${this.props.className}`
      : this.props.className
  }

  get newClassName() {
    return this.state.validationErrors.length > 0
      ? `error-field ${this.props.className}`
      : this.props.className
  }

  losePristine() {
    this.setState({
      pristine: false,
    })
  }
}

AbstractInput.propTypes = {
  required: PropTypes.bool,
  className: PropTypes.string,
  errorText: PropTypes.string,
  validationKey: PropTypes.string,
  errorsDispatcher: PropTypes.any,
  errors: PropTypes.array,
  showError: PropTypes.bool,
  inputRef: PropTypes.func,
}

AbstractInput.defaultProps = {
  required: false,
  className: '',
  errorText: '',
  validationKey: '',
  errorsDispatcher: null,
  errors: [],
  showError: false,
}
